import { EFileType } from '@/constant';
import { TGetDefaultInfoUnitResponse } from '@/services';
import { formatDate, toBoolean } from '@/utils';

export const formatDefaultInfoUnitDetail = (
	input: TGetDefaultInfoUnitResponse
) => {
	return {
		...input,
		registDt: formatDate(input.registDt),
		updateDt: formatDate(input.updateDt),
		fileList: input?.resFile
			? [
					{
						...input?.resFile,
						uid: input?.resFile?.fileId,
						fileType: EFileType.SERVER,
						size: input?.resFile?.fileSize,
					},
				]
			: [],
		isActivatedApplicantNoti: toBoolean(input?.isActivatedApplicantNoti),
		isActivatedFranchiseNoti: toBoolean(input?.isActivatedFranchiseNoti),
		isActivatedExpApplicantSms: toBoolean(input?.isActivatedExpApplicantSms),
		isActivatedExpApplicantNoti: toBoolean(input?.isActivatedExpApplicantNoti),
	};
};
